import { memo } from 'react';

const DiagnosisDeleteBtn = ({ action, itemName, delId, isDelBtn = true }) => {
  return (
    <>
      {isDelBtn && (
        <i
          className="far fa-times-circle"
          style={{ cursor: 'pointer', flexShrink: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            action(itemName, delId);
          }}
        ></i>
      )}
    </>
  );
};

export default memo(DiagnosisDeleteBtn);
